import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import throttle from 'lodash/throttle';

var withViewportMeta = function withViewportMeta(WrappedComponent) {
  return /*#__PURE__*/function (_Component) {
    _inherits(PageTop, _Component);

    var _super = _createSuper(PageTop);

    function PageTop() {
      var _this;

      _classCallCheck(this, PageTop);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "state", {
        pageWidth: window.innerWidth,
        scrollTop: window.pageYOffset
      });

      _defineProperty(_assertThisInitialized(_this), "handleScroll", throttle(function () {
        if (_this.state.scrollTop !== window.pageYOffset || _this.state.pageWidth !== window.innerWidth) {
          _this.setState({
            pageWidth: window.innerWidth,
            scrollTop: window.pageYOffset
          });
        }
      }, 10));

      return _this;
    }

    _createClass(PageTop, [{
      key: "render",
      value: function render() {
        return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, this.state, this.props));
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        window.addEventListener('resize', this.handleScroll);
        window.addEventListener('scroll', this.handleScroll);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        window.removeEventListener('resize', this.handleScroll);
        window.removeEventListener('scroll', this.handleScroll);
      }
    }]);

    return PageTop;
  }(Component);
};

export { withViewportMeta };